/* tslint:disable */
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by a tool.
//
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
import { HttpService, CustomAxiosRequestConfig } from "@infrastructure/transport/httpservice";
import { AppConfig } from "@infrastructure/config/config";


export class OrganisationController {
        private disableErrorHandling: boolean = false;
        constructor(config?: CustomAxiosRequestConfig){
            this.disableErrorHandling = config && config.disableErrorHandling || false;
        }
    
        public getCurrentOrganisation = (): Promise<OperationResult<ProxyModel.OrganisationViewModel,any>> => {
            const route = `api/Organisation/`;
            return HttpService.Instance.request<ProxyModel.OrganisationViewModel,any>({
                url: HttpService.Instance.GetUrl(route, 'OrganisationController','GetCurrentOrganisation'),
                method: "get",
                data: null,
                disableErrorHandling: this.disableErrorHandling,
                headers: {'X-Requested-With': 'XMLHttpRequest'}
            });
        };
    
        public getContactDetails = (): Promise<OperationResult<ProxyModel.ContactDetailViewModel[],any>> => {
            const route = `api/Organisation/`;
            return HttpService.Instance.request<ProxyModel.ContactDetailViewModel[],any>({
                url: HttpService.Instance.GetUrl(route, 'OrganisationController','GetContactDetails'),
                method: "get",
                data: null,
                disableErrorHandling: this.disableErrorHandling,
                headers: {'X-Requested-With': 'XMLHttpRequest'}
            });
        };
    
    
    
        public termsAndConditionsLink = (): string => {
            const route = `api/Organisation/`;
            return `/${AppConfig.Instance.getTenant()}/${HttpService.Instance.GetUrl(route, "OrganisationController","TermsAndConditions")}`;
        };
    
}